<template>
  <v-app>
    <navigation-drawer v-show="auth" :toggle.sync="drawer" clipped app></navigation-drawer>
    <app-bar :drawer.sync="drawer"></app-bar>
    <v-system-bar
      color="error"
      height="24"
      dark
      app
      class="justify-center align-center"
      v-if="isStagingSite"
    >
      <v-icon>mdi-dev-to</v-icon>
      <span>測試站</span>
    </v-system-bar>
    <v-main>
      <v-snackbar v-model="snackbarActive" top :timeout="3000" :color="snackbar.color">
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn
            text
            v-bind="attrs"
            @click="setSnackbar({ active: false })"
          >
            {{ $t('關閉') }}
          </v-btn>
        </template>
      </v-snackbar>
      <news-dialog :news="news" @read="readNews"></news-dialog>
      <v-container fluid :fill-height="$route.meta.fillHeight">
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-footer app></v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import NavigationDrawer from '../components/core/NavigationDrawer';
import AppBar from '../components/core/AppBar';
import NewsDialog from '../components/core/NewsDialog';
import API from '../api';
import LogRocket from 'logrocket';

if (process.env.MIX_LOGROCKET_ENABLED == 'true') {
  LogRocket.init('3zxqdb/nicehenry', {
    release: process.env.MIX_BUILD_HASH,
    console: {
      shouldAggregateConsoleErrors: true,
    },
  });
}

export default {
  components: {
    NavigationDrawer,
    AppBar,
    NewsDialog,
  },

  data() {
    return {
      drawer: false,
      news: null,
      unreadNews: null,
      isStagingSite: process.env.MIX_STAGING_SITE === 'true',
    }
  },

  computed: {
     snackbarActive: {
      get() {
        return this.snackbar.active;
      },

      set(value) {
        this.setSnackbar({ active: value });
      }
    },

    ...mapState(['snackbar', 'user']),
    ...mapGetters(['auth']),
  },

  watch: {
    user() {
      if (this.user) {
        if (process.env.MIX_LOGROCKET_ENABLED == 'true') {
          LogRocket.identify(this.user.id, {
            name: this.user.phone,
            account: this.user.account,
            role: this.user.role,
            vendor_id: this.user.vendor.id,
            vendor_no: this.user.vendor.no,
          });
        }

        this.fetchUnreadNews();
      }
    }
  },

  methods: {
    async fetchUnreadNews() {
      const response = await API.news.getUnread(this.$root.$i18n.locale);
      this.unreadNews = response.data.result;
      this.news = this.unreadNews.shift();
    },

    readNews(news) {
      API.news.read(news.id);
      if (this.unreadNews.length > 0) {
        this.news = this.unreadNews.shift();
      }
    },

    ...mapActions(['setSnackbar']),
  }
}
</script>
